// 案例管理
import http from "@/jslibs/axios/http";

// 案例列表
export const list = (data) => http.get(`/v1/cms/MCase`, data);

// 案例添加
export const add = (data) => http.post(`/v1/cms/MCase`, data);

// 案例编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/MCase/${uuid}`, data);

// 案例详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/MCase/${cuuid}`, data);

// 案例删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/MCase/${cuuid}`);